import React from "react";
import './Logos.css';
import brr  from '../../assets/img/project_logos/brr.png';
import chn  from '../../assets/img/project_logos/chn.png';
import cpb  from '../../assets/img/project_logos/cpb.png';
import fng  from '../../assets/img/project_logos/fng.png';
import imd  from '../../assets/img/project_logos/imd.png';
import osb  from '../../assets/img/project_logos/osb.png';
import pbx  from '../../assets/img/project_logos/pbx.png';
import pds  from '../../assets/img/project_logos/pds.png';
import pxd  from '../../assets/img/project_logos/pxd.png';
import srn  from '../../assets/img/project_logos/srn.png';
import tbx  from '../../assets/img/project_logos/tbx.png';
import tgz  from '../../assets/img/project_logos/tgz.png';
import wof  from '../../assets/img/project_logos/wof.png';
import wsf  from '../../assets/img/project_logos/wsf.png';
// import { Carousel } from 'react-responsive-carousel'; //need a carousel with different autoplay
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";
import 'swiper/css';
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default class Logos extends React.Component {

	renderLogosCarousel(slidesPerView){
		const logoList=[
			{pic: chn, link:"https://t.me/chainlinkofficial/352910"},
			{pic: pbx, link:"https://www.paintboxlabs.com/"},
			{pic: tbx, link:"https://iamtribex.com/"},
			{pic: pxd, link:"https://pixod.com/"},
			{pic: osb, link:"https://ome.osbiome.com/"},
			{pic: wof, link:"https://worldoffootball.io/"},
			{pic: pds, link:"https://www.pixeldust.tv/"},
			{pic: imd, link:"https://internetmadenft.com/"},
			{pic: srn, link:"https://surronmusic.com/"},
			{pic: fng, link:"https://freaksnguilds.com/"},
			{pic: cpb, link:"https://www.cryptobozos.com/"},
			{pic: tgz, link:"https://www.taggerz.xyz/"},
			{pic: wsf, link:"https://www.wallstfam.com/"},
			{pic: brr, link:"https://www.beyondrarity.com/"}
		]


		return <Swiper
				modules={[Autoplay, Pagination, Navigation]}
				slidesPerView={slidesPerView}
				centeredSlides={true}
				loop={true}
				autoplay={{delay:1000, disableOnInteraction:false}}
			>
			{logoList.map((l, i)=>{
				return <SwiperSlide key={l.link}>
					<a href={l.link} target="_blank" rel="noreferrer" >
						<div className="carousel-logo-container" key={l.pic}>
							<img src={l.pic} alt=""/>
						</div>
					</a>
				</SwiperSlide>
			})}
		</Swiper>
	}

	render() {

		return (
		<AnimationOnScroll initiallyVisible={false} animateIn="fadeInAnimation" animateOnce={true} delay={0}>
			<div className="logos-container">
				<div className="logos-big">
					{this.renderLogosCarousel(5)}
				</div>
				<div className="logos-small">
					{this.renderLogosCarousel(4)}
				</div>
			</div>
		</AnimationOnScroll>
		);
	}
}
